import api from './api'

const API = '/api/analytics'

export const Analytic = {
  getOverAllSummary: function(form) {
    return api.create(API + '/over-all-summary', form)
  },
  getSummary: function(form) {
    return api.create(API + '/summary', form)
  },
  getSummaryByLeaders: function(form) {
    return api.create(API + '/summary-by-leaders', form)
  },
}

